import { SpaceBetween } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useRef } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setData, setLoading } from '../../../../commons/functions';


import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import React from 'react';
import BookingGenerate, { BookingGenerateHandles } from '../../../../../components/generates/BookingGenerate';
import { ItemBooking } from '../../../../../resources/types';
dayjs.extend(isBetween);


const pageSize = 20;
interface HourOption {
    value: string;
    label: string;
}
export const OPSPlanningBookPage = () => {


    const { menu, idUser, data } = useGlobalState();


    const handleBook = async (booking: ItemBooking) => {
        console.log("handleBook", booking)
        setLoading(true);
        if (booking && booking?.dateStart && booking.dateStart !== ""
            && booking?.dateEnd && booking.dateEnd !== ""
            && booking?.timeStart && booking.timeStart !== ""
            && booking?.timeEnd && booking.timeEnd !== ""
            && booking?.idEquipment > 0 && booking.idUserPilot > 0
        ) {
            try {
                const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/bookings/add',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        commit: true,
                        startDate: booking.dateStart + " " + booking.timeStart + ":00",
                        endDate: booking.dateEnd + " " + booking.timeEnd + ":00",
                        idEquipment: booking.idEquipment,
                        idUserPilot: booking.idUserPilot,
                        idUserInstructor: booking.idUserInstructor,

                        idBookingType: booking.idBookingType,
                        idUser: booking.idUserPilot,
                        idInstructor: booking.idUserInstructor,
                        obsBooking: `Reserva emitida por ${getUser(idUser, data).displayName}; ${booking.obsBooking ?? ""}`,
                        obs: `Reserva emitida por ${getUser(idUser, data).displayName}; ${booking.obsBooking}`,
                        towType: booking.towType,
                        pax: booking.pax,
                        override: true
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code === 0) {
                    clearBooking()
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }

    };

    const bookingRef = useRef<BookingGenerateHandles>(null);
    const clearBooking = () => {
        //console.log("bookingRef.current", bookingRef.current)
        if (bookingRef.current) {
            bookingRef.current.clearBooking();
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="xs">

                    <BookingGenerate
                        ref={bookingRef}
                        urlPreBook="/private/admin/bookings/add"
                        idUser={0}
                        idGroupTypes={[2875, 119737]}
                        onChange={(booking) => {
                            //console.log(booking)
                            handleBook(booking)
                        }}
                    />



                </SpaceBetween >
            }
        />

    );
};